import { AutomaticEmailStatus } from "@daytrip/legacy-enums";
import { Expose, Transform, Type } from "class-transformer";

import { statusGetter } from "../statusGetter";
import { TransformToDate } from "../transformers/transformToDate";

import type { AutomaticEmail } from "./AutomaticEmail";

export class AutomaticEmailBase {
    @Expose()
    @TransformToDate
    public scheduledUntil?: Date;

    @Expose()
    @TransformToDate
    public sentAt?: Date;

    @Expose()
    @TransformToDate
    public acceptedAt?: Date;

    @Expose()
    @TransformToDate
    public rejectedAt?: Date;

    @Expose()
    @TransformToDate
    public deliveredAt?: Date;

    @Expose()
    @TransformToDate
    public failedAt?: Date;

    @Expose()
    @TransformToDate
    public openedAt?: Date;

    @Expose()
    @TransformToDate
    public clickedAt?: Date;

    @Expose()
    @Type(() => Date)
    @Transform((value) => (!value ? undefined : new Date(value)))
    public unsubscribedAt?: Date;

    @Expose()
    @Type(() => Date)
    @Transform((value) => (!value ? undefined : new Date(value)))
    public complainedAt?: Date;

    @Expose()
    @Type(() => Date)
    @Transform((value) => (!value ? undefined : new Date(value)))
    public storedAt?: Date;

    public get status(): AutomaticEmailStatus {
        return statusGetter(this, AutomaticEmailBase, AutomaticEmailStatus);
    }

    public static statusPrototype(status: AutomaticEmailStatus): AutomaticEmailBase {
        const defined = new Date();

        switch (status) {
            case AutomaticEmailStatus.Failed:
                return {
                    failedAt: defined,
                    rejectedAt: undefined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Complained:
                return {
                    complainedAt: defined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Unsubscribed:
                return {
                    unsubscribedAt: defined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Delivered:
                return {
                    deliveredAt: defined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Rejected:
                return {
                    rejectedAt: defined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Opened:
                return {
                    openedAt: defined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Clicked:
                return {
                    clickedAt: defined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Accepted:
                return {
                    acceptedAt: defined,
                    failedAt: undefined,
                    complainedAt: undefined,
                    openedAt: undefined,
                    unsubscribedAt: undefined,
                    deliveredAt: undefined,
                    rejectedAt: undefined,
                    clickedAt: undefined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Scheduled:
                return {
                    scheduledUntil: defined,
                    sentAt: undefined,
                } as unknown as AutomaticEmail;

            case AutomaticEmailStatus.Requested:
            default:
                return {
                    sentAt: defined,
                    failedAt: undefined,
                    openedAt: undefined,
                    deliveredAt: undefined,
                    clickedAt: undefined,
                    complainedAt: undefined,
                    unsubscribedAt: undefined,
                    acceptedAt: undefined,
                } as unknown as AutomaticEmail;
        }
    }
}
